var map = {
	"./1.png": "137d",
	"./2.png": "e28a",
	"./3.png": "40d1",
	"./4.png": "c05d",
	"./5.png": "6696",
	"./6.png": "ac66",
	"./7.png": "df64",
	"./8.png": "ffd62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ad7";